// ライブラリのインポート
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import HandymanIcon from "@mui/icons-material/Handyman";
import ListIcon from "@mui/icons-material/List";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import CssBaseline from "@mui/material/CssBaseline";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Helmet, HelmetProvider } from "react-helmet-async";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
// ローカルのインポート
import FileUploader from "./FileUploader";
import Footer from "./Footer";
import Header from "./Header";
// import RegistrationLists from "./RegistrationLists";
import GetInformation from "./GetInformation";
import ProcStatusLists from "./ProcStatusLists";
import SalesAgentLists from "./SalesAgentLists";

export const AGENCY_SB_INDEX = 0; // apiID, 配列番号
export const AGENCY_SNC_INDEX = 1;
export const AGENCY_DIS_INDEX = 2;
export const AGENCY_TOO_INDEX = 3;

export const agencyInformation = [
  {
    apiID: 0,
    path: "retistrationSB",
    inFilePattern: 1,
    distributor: "sb",
    ocrModelNo: "2",
    displayName: "SB C&S",
  },
  {
    apiID: 1,
    path: "retistrationSNC",
    inFilePattern: 4,
    distributor: "snc",
    ocrModelNo: "5",
    displayName: "SYNNEX",
  },
  {
    apiID: 2,
    path: "retistrationDIS",
    inFilePattern: 1,
    distributor: "dis",
    ocrModelNo: "1",
    displayName: "DIS",
  },
  {
    apiID: 3,
    path: "retistrationTOO",
    inFilePattern: 3,
    distributor: "too",
    ocrModelNo: "7",
    displayName: "Too",
    displayName_c: "Too 注文書",
    displayName_h: "Too 発注書",
    displayName_h2: "Too 発注書",
  },
];

const menuItems = [
  { index: 0, to: "/procStatusLists", Icon: ListIcon, primary: "処理待ち" },
  { index: 1, to: "/procEndStatusLists", Icon: ListIcon, primary: "完了" },
  {
    index: 2,
    to: "retistrationSB",
    Icon: AppRegistrationIcon,
    primary: "SB C&S",
  },
  {
    index: 3,
    to: "retistrationSNC",
    Icon: AppRegistrationIcon,
    primary: "SYNNEX",
  },
  {
    index: 4,
    to: "retistrationDIS",
    Icon: AppRegistrationIcon,
    primary: "DIS",
  },
  {
    index: 5,
    to: "retistrationTOO",
    Icon: AppRegistrationIcon,
    primary: "Too",
  },
  {
    index: 6,
    to: "/SalesAgentLists",
    Icon: HandymanIcon,
    primary: "販売代理店",
  },
];

export const ocrModel2Agency = [
  // ocrModel：1.dis, 2.sb, 3.too_c, 4.too_h, 5.snc、6.too_h2、7.too
  0, // 配列は大切、未使用も含めてなので削除しないこと
  agencyInformation[2].displayName, //  AGENCY_DIS_INDEX,
  agencyInformation[0].displayName, //  AGENCY_SB_INDEX,
  agencyInformation[3].displayName_c, //  AGENCY_TOO_INDEX,　注文書
  agencyInformation[3].displayName_h, //  AGENCY_TOO_INDEX,　発注書（横長版）＊未使用
  agencyInformation[1].displayName, //  AGENCY_SNC_INDEX,
  agencyInformation[3].displayName_h2, //  AGENCY_TOO_INDEX,　発注書（縦長版
  agencyInformation[3].displayName, //  AGENCY_TOO_INDEX
];

const drawerWidth = 200;
const common_color_menu = "#2a5772";
const common_color_child = "#e0e0e0";
const common_color_selected = "#2a5772";
const headerFontSize = "h7";

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
    backgroundColor: common_color_child,
  })
);

const FireNav = styled(List)({
  "& .MuiListItemButton-root": {
    paddingLeft: 20,
    paddingRight: 10,
  },
  "& .MuiListItemIcon-root": {
    minWidth: 0,
    marginRight: 10,
    marginLeft: 15,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function PersistentDrawerLeft(props) {
  // const theme = useTheme();

  // state宣言
  const [userEmail, setUserEmail] = useState(""); // ログインユーザーEmail
  const [userName, setUserName] = useState(""); // ログインユーザー名
  const [cookies, setCookie, removeCookie] = useCookies(); // Cookieのユーザー権限
  const [version, setVersion] = useState(); // Version
  const [versionId, setVersionId] = useState(""); // Version番号
  const [openVersion, setOpenVersion] = useState(false); // Versionダイアログ
  const [open, setOpen] = useState(""); // サイドバーの開閉
  const [listOrderOpen, setListOrderOpen] = useState(true); // リスト開閉(利用者)
  const [listRegistrationOpen, setListRegistrationOpen] = useState(true); // リスト開閉(利用者)
  const [listMentenanceModeOpen, setListMentenanceModeOpen] = useState(true); // リスト開閉(管理者)
  // const [lists, setLists] = useState([]); // リスト情報

  // カラー設定
  const common_color_navi = "#4790BB";
  //  const active_sort_color = "#caeafe";

  const [selectedIndex, setSelectedIndex] = useState(); // リスト選択情報
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  // 申請書登録リスト開閉
  const handleListClickRegistration = () => {
    setListRegistrationOpen(!listRegistrationOpen);
  };
  // 申請書一覧リスト開閉
  const handleListClickOrder = () => {
    setListOrderOpen(!listOrderOpen);
  };
  // 管理リスト開閉
  const handleListClickMentenanceMode = () => {
    setListMentenanceModeOpen(!listMentenanceModeOpen);
  };

  // URLでメニュー選択
  const setIndex = () => {
    const urlPathname = window.location.pathname; // URLのドメイン以降のパス取得
    switch (urlPathname) {
      case "/procStatusLists":
        setSelectedIndex(0);
        break;
      case "/procEndStatusLists":
        setSelectedIndex(1);
        break;
      case "/" + agencyInformation[AGENCY_SB_INDEX].path:
        setSelectedIndex(2);
        break;
      case "/" + agencyInformation[AGENCY_SNC_INDEX].path:
        setSelectedIndex(3);
        break;
      case "/" + agencyInformation[AGENCY_DIS_INDEX].path:
        setSelectedIndex(4);
        break;
      case "/" + agencyInformation[AGENCY_TOO_INDEX].path:
        setSelectedIndex(5);
        break;
      case "/SalesAgentLists":
        setSelectedIndex(6);
        break;

      default:
        // Handle default case here
        break;
    }
  };

  // マウント時に1回だけ実行
  useEffect(() => {
    setIndex();
  }, []);

  const ListItemLink = ({
    selectedIndex,
    index,
    handleClick,
    to,
    Icon,
    primary,
  }) => (
    <ListItemButton
      selected={selectedIndex === index}
      onClick={(event) => handleClick(event, index)}
      sx={{
        "&.Mui-selected": {
          color: common_color_selected,
          backgroundColor: common_color_child,
        },
        "&.MuiListItemButton-root:hover": {
          backgroundColor: common_color_child,
          color: common_color_selected,
        },
        pl: 4,
      }}
      to={to}
    >
      <ListItemIcon>
        <Icon
          sx={{
            color: selectedIndex === index ? common_color_selected : "white",
          }}
        />
      </ListItemIcon>
      <ListItemText
        primary={primary}
        primaryTypographyProps={{ variant: headerFontSize }}
      />
    </ListItemButton>
  );

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <React.Fragment>
        <HelmetProvider>
          <Helmet>
            <style>{`body { background-color: ${common_color_child}; }`}</style>
          </Helmet>
        </HelmetProvider>
      </React.Fragment>

      {/* ヘッダー */}
      {/* propsを渡す */}
      <Header
        userName={userName}
        userEmail={userEmail}
        removeCookie={removeCookie}
        open={open}
        setOpen={setOpen}
        common_color_navi={common_color_navi}
        headerFontSize={headerFontSize}
        cookies={cookies}
        setCookie={setCookie}
        version={version}
        versionId={versionId}
        openVersion={openVersion}
        setOpenVersion={setOpenVersion}
      />
      <GetInformation
        setUserName={setUserName}
        setUserEmail={setUserEmail}
        setCookie={setCookie}
        removeCookie={removeCookie}
        setVersion={setVersion}
        setVersionId={setVersionId}
      />
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            backgroundColor: common_color_menu,
            color: "white",
            border: 0,
          },
        }}
        variant="persistent"
        anchor="left"
        open={cookies.sideOpen === "true" ? true : false}
      >
        <DrawerHeader></DrawerHeader>

        <FireNav component="nav" disablePadding>
          <List>
            {/* 申請書一覧 */}
            <ListItemButton onClick={handleListClickOrder}>
              {listOrderOpen ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
              <ListItemText
                primary={"申請書一覧"}
                primaryTypographyProps={{ variant: headerFontSize }}
              />
            </ListItemButton>
            <Collapse in={listOrderOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {menuItems.slice(0, 2).map((item) => (
                  <ListItemLink
                    key={item.index}
                    selectedIndex={selectedIndex}
                    index={item.index}
                    handleClick={handleListItemClick}
                    to={item.to}
                    Icon={item.Icon}
                    primary={item.primary}
                  />
                ))}
              </List>
            </Collapse>

            {/* 申請書登録 */}
            <ListItemButton onClick={handleListClickRegistration}>
              {listRegistrationOpen ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowRightIcon />
              )}
              <ListItemText
                primary={"申請書登録"}
                primaryTypographyProps={{ variant: headerFontSize }}
              />
            </ListItemButton>
            <Collapse in={listRegistrationOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {menuItems.slice(2, 6).map((item) => (
                  <ListItemLink
                    key={item.index}
                    selectedIndex={selectedIndex}
                    index={item.index}
                    handleClick={handleListItemClick}
                    to={item.to}
                    Icon={item.Icon}
                    primary={item.primary}
                  />
                ))}
              </List>
            </Collapse>

            {/* 管理 */}
            <ListItemButton onClick={handleListClickMentenanceMode}>
              {listMentenanceModeOpen ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowRightIcon />
              )}
              <ListItemText
                primary={"管理"}
                primaryTypographyProps={{ variant: headerFontSize }}
              />
            </ListItemButton>
            <Collapse in={listMentenanceModeOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {menuItems.slice(6, 7).map((item) => (
                  <ListItemLink
                    key={item.index}
                    selectedIndex={selectedIndex}
                    index={item.index}
                    handleClick={handleListItemClick}
                    to={item.to}
                    Icon={item.Icon}
                    primary={item.primary}
                  />
                ))}
              </List>
            </Collapse>
          </List>
        </FireNav>
      </Drawer>
      <Main open={cookies.sideOpen === "true" ? true : false}>
        <DrawerHeader />
        <RouterProvider
          router={createBrowserRouter([
            {
              path: "/",
              element: <Navigate to="/procStatusLists" />,
            },
            {
              path: "procStatusLists",
              element: <ProcStatusLists procMode={"Processing"} />,
            },
            {
              path: "procEndStatusLists",
              element: <ProcStatusLists procMode={"Completed"} />,
            },
            {
              path: "SalesAgentLists",
              element: <SalesAgentLists />,
            },
            {
              path: agencyInformation[AGENCY_SB_INDEX].path,
              element: (
                <FileUploader sale_agent={agencyInformation[AGENCY_SB_INDEX]} />
              ),
            },
            {
              path: agencyInformation[AGENCY_SNC_INDEX].path,
              element: (
                <FileUploader
                  sale_agent={agencyInformation[AGENCY_SNC_INDEX]}
                />
              ),
            },
            {
              path: agencyInformation[AGENCY_DIS_INDEX].path,
              element: (
                <FileUploader
                  sale_agent={agencyInformation[AGENCY_DIS_INDEX]}
                />
              ),
            },
            {
              path: agencyInformation[AGENCY_TOO_INDEX].path,
              element: (
                <FileUploader
                  sale_agent={agencyInformation[AGENCY_TOO_INDEX]}
                />
              ),
            },
          ])}
        />
      </Main>
      <Footer common_color_navi={common_color_navi} />
    </Box>
  );
}
